import { motion } from "framer-motion";
import Seo from "@/components/Seo";

const sections = [
  {
    title: "1. Responsable du traitement",
    body: (
      <>
        <p>Le responsable du traitement des données personnelles est :</p>
        <ul className="mt-3 space-y-1.5">
          <li><strong className="text-white">LMB SERVICES</strong></li>
          <li>EURL au capital de 1 000 €</li>
          <li>225 avenue des Marronniers</li>
          <li>38300 Bourgoin-Jallieu — France</li>
          <li>E-mail : <a href="mailto:pixora.photobooth38@gmail.com" className="text-[#C9A962] hover:underline">pixora.photobooth38@gmail.com</a></li>
          <li>Téléphone : <a href="tel:+33745709881" className="text-[#C9A962] hover:underline">07 45 70 98 81</a></li>
        </ul>
      </>
    ),
  },
  {
    title: "2. Données collectées",
    body: (
      <>
        <p>Lorsque vous utilisez le formulaire de contact du site, nous pouvons être amenés à collecter les informations suivantes :</p>
        <ul className="mt-3 list-disc list-inside space-y-1.5">
          <li>Nom et prénom</li>
          <li>Adresse e-mail</li>
          <li>Numéro de téléphone</li>
          <li>Contenu de votre message</li>
        </ul>
        <p className="mt-3">Seules les informations que vous choisissez de transmettre sont collectées.</p>
      </>
    ),
  },
  {
    title: "3. Finalités du traitement",
    body: (
      <>
        <p>Les données personnelles sont utilisées uniquement pour :</p>
        <ul className="mt-3 list-disc list-inside space-y-1.5">
          <li>répondre à vos demandes de renseignements ;</li>
          <li>établir un devis ;</li>
          <li>organiser une prestation de location de photobooth ;</li>
          <li>assurer le suivi de nos échanges commerciaux.</li>
        </ul>
        <p className="mt-3">Les données ne sont jamais revendues ni cédées à des tiers à des fins commerciales.</p>
      </>
    ),
  },
  {
    title: "4. Base légale du traitement",
    body: (
      <>
        <p>Les traitements reposent sur :</p>
        <ul className="mt-3 list-disc list-inside space-y-1.5">
          <li>votre consentement lorsque vous remplissez le formulaire de contact ;</li>
          <li>l'exécution de mesures précontractuelles lorsque vous demandez un devis ou des informations concernant une prestation.</li>
        </ul>
      </>
    ),
  },
  {
    title: "5. Durée de conservation",
    body: <p>Les données sont conservées uniquement pendant la durée nécessaire au traitement de votre demande ainsi que pour satisfaire aux obligations légales applicables.</p>,
  },
  {
    title: "6. Destinataires des données",
    body: <p>Les données sont exclusivement destinées à LMB SERVICES ainsi qu'aux prestataires techniques intervenant dans le fonctionnement du site lorsque cela est nécessaire.</p>,
  },
  {
    title: "7. Sécurité",
    body: <p>LMB SERVICES met en œuvre des mesures techniques et organisationnelles appropriées afin d'assurer la sécurité et la confidentialité des données personnelles.</p>,
  },
  {
    title: "8. Vos droits",
    body: (
      <>
        <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :</p>
        <ul className="mt-3 list-disc list-inside space-y-1.5">
          <li>droit d'accès ;</li>
          <li>droit de rectification ;</li>
          <li>droit d'effacement ;</li>
          <li>droit d'opposition ;</li>
          <li>droit à la limitation du traitement ;</li>
          <li>droit à la portabilité de vos données.</li>
        </ul>
        <p className="mt-3">
          Pour exercer ces droits, vous pouvez contacter :{" "}
          <a href="mailto:pixora.photobooth38@gmail.com" className="text-[#C9A962] hover:underline">pixora.photobooth38@gmail.com</a>
        </p>
        <p className="mt-3">Si vous estimez que vos droits ne sont pas respectés, vous pouvez déposer une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL).</p>
      </>
    ),
  },
  {
    title: "9. Cookies",
    body: (
      <>
        <p>Le site utilise uniquement les cookies nécessaires à son fonctionnement.</p>
        <p className="mt-3">Si des services de mesure d'audience ou publicitaires (Google Analytics, Google Tag Manager, Meta Pixel ou équivalent) sont installés, votre consentement sera recueilli avant leur dépôt, conformément à la réglementation en vigueur.</p>
        <p className="mt-3">Vous pourrez modifier vos préférences à tout moment grâce au gestionnaire de cookies disponible sur le site.</p>
      </>
    ),
  },
];

export default function PolitiqueConfidentialite() {
  return (
    <div className="pt-24 md:pt-32 lg:pt-36 pb-24 bokeh-strong min-h-screen" data-testid="politique-confidentialite-page">
      <Seo
        title="Politique de confidentialité | Pixora Photobooth"
        description="Politique de confidentialité et traitement des données personnelles sur Pixora Photobooth."
        path="/politique-confidentialite"
        noindex
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-14 text-center"
        >
          <p className="text-xs tracking-[0.3em] text-[#C9A962] mb-4">PROTECTION DES DONNÉES</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
            Politique de <span className="text-[#C9A962]">Confidentialité</span>
          </h1>
        </motion.div>

        <div className="space-y-8">
          {sections.map((s, i) => (
            <motion.section
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              className="p-6 sm:p-8 rounded-2xl bg-black/40 border border-[#C9A962]/20 backdrop-blur-sm"
              data-testid={`privacy-section-${i}`}
            >
              <h2 className="text-xl sm:text-2xl font-semibold text-[#C9A962] mb-4">{s.title}</h2>
              <div className="text-[#D8CCA8] text-[15px] leading-relaxed">{s.body}</div>
            </motion.section>
          ))}
        </div>
      </div>
    </div>
  );
}
